(($) => {

    /**
     * Finds focusable descendants.
     */
    $.fn.focusable = function () {
        return this.find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
    };

})(jQuery);
